<template>

  <div class="wrapper">

    <v-sidebar activeNavItem="myprofile"></v-sidebar>

    <div class="main-panel">

      <v-navbar :title="'Contacts'"></v-navbar>

      <form @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card">
                        <div class="card-header">
                          <h4 class="card-title">Edit Contact</h4>
                        </div>



                        <div class="card-body">
                          <div class="row form">

                            <div class="col-12 col-sm-12">
                              <div class="form-group">
                                <label for="addContact_email">Email</label>
                                <input type="text" id="email" name="email" v-model="email" class="form-control" autocomplete="new-password" v-validate="'required|email'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('email')}" disabled>
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="addContact_name">Name</label>
                                <input type="text" disabled="true" id="name" name="name" v-model="name" class="form-control" v-validate="'required|min:2'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('name') }">
                              </div>
                            </div>

                              <!-- 
                              <div class="form-group">
                                <label for="addContact_type">Type</label>
                                <select id="type" disabled="true" class="form-control" v-model="type" style="-webkit-appearance: none; -webkit-border-radius: 0px;">
                                  <option value="Person">Person</option>
                                  <option value="Company">Company</option>
                                  <option value="Division">Division</option>
                                </select>
                              </div> -->

                           <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Office</label>
                                <input type="text" id="phoneoffice" name="phoneoffice" v-model="phoneoffice" class="form-control">
                              </div>
                            </div>

                           <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Cell</label>
                                <input type="text" id="phonecell" name="phonecell" v-model="phonecell" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Fax</label>
                                <input type="text" id="fax" name="fax" v-model="fax" class="form-control">
                              </div>
                            </div>


                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Position Description</label>
                                <input type="text" id="position" name="position" v-model="position" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">

                              </div>
                            </div>


                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="company" :title="companyId">Company</label>
                                <input type="text" id="company" name="company" v-on:keyup="companyLiveSearch($event)" autocomplete="new-password" v-model="company" class="form-control" disabled="true">
                                <div id="companyLiveSearch" class="customLiveSearch">
                                  <template v-for="row in companyrows">
                                    <div class="customLiveSearchElement" v-on:click="companySelected(row)">{{ row.display }}</div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="division">Division</label>
                                <input type="text" id="division" name="divison" v-model="division" v-on:keyup="divisionChange()" class="form-control" disabled="true">
                              </div>
                            </div>


                            <div class="col-12">
                              <div class="form-group">
                                <label for="address">Address</label>
                                <input type="text" disabled id="contactEditAddressAutoComplete" name="address" class="form-control" onfocus="this.setAttribute('autocomplete', 'new-password');">
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="form-group">
                                <LeafletMap v-if="hasAddressLocation" height="200px" :starting-center="mapCenter" :points="addressMapPoint" />
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="address">Street Address</label>
                                <input type="text" disabled="true" id="address" name="address" v-model="address" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="city">City</label>
                                <input type="text" disabled="true" id="city" name="city" v-model="city" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="province">State / Province</label>

                                <select id="province" class="form-control" name="province" v-model="province" v-on:change="onProvinceChange(province)" style="-webkit-appearance: none; -webkit-border-radius: 0px;" disabled="true">
                                  <option value="">Select One</option>
                                  <optgroup label="Canadian Provinces">
                                    <option value="AB">Alberta</option>
                                    <option value="BC">British Columbia</option>
                                    <option value="MB">Manitoba</option>
                                    <option value="NB">New Brunswick</option>
                                    <option value="NF">Newfoundland and Labrador</option>
                                    <option value="NT">Northwest Territories</option>
                                    <option value="NS">Nova Scotia</option>
                                    <option value="NU">Nunavut</option>
                                    <option value="ON">Ontario</option>
                                    <option value="PE">Prince Edward Island</option>
                                    <option value="QC">Quebec</option>
                                    <option value="SK">Saskatchewan</option>
                                    <option value="YT">Yukon Territory</option>
                                  </optgroup>
                                  <optgroup label="U.S. States/Territories">
                                    <option value="AK">Alaska</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DC">District of Columbia</option>
                                    <option value="DE">Delaware</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="IA">Iowa</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MD">Maryland</option>
                                    <option value="ME">Maine</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MT">Montana</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NY">New York</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="PR">Puerto Rico</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VA">Virginia</option>
                                    <option value="VT">Vermont</option>
                                    <option value="WA">Washington</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WY">Wyoming</option>
                                  </optgroup>
                                </select>
                              </div>

                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="postal">Postal / Zip</label>
                                <input type="text" disabled="true" id="postal" name="postal" v-model="postal" class="form-control">
                              </div>

                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="country">Country</label>
                                <select id="country" :disabled="!isCompanyOwner" class="form-control" v-model="country" style="-webkit-appearance: none; -webkit-border-radius: 0px;">
                                  <option>Canada</option>
                                  <option>United States</option>
                                </select>
                              </div>
                            </div>



                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="phone">Phone Number</label>
                                <input type="text" :disabled="!isCompanyOwner" id="phone" name="phone" v-model="phone" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="website">Company Website</label>
                                <input type="text" :disabled="!isCompanyOwner" id="website" name="website" v-model="website" class="form-control">
                              </div>
                            </div>

                            
                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="customsBroker">Customs Broker</label>
                                <input type="text" :disabled="!isCompanyOwner" id="customsBroker" name="customsBroker" v-model="customsBroker" class="form-control" v-on:keyup="customsBrokerLiveSearch($event)" autocomplete="new-password">
                                <div id="customsBrokerLiveSearch" class="customLiveSearch">
                                  <template v-for="row in customsBrokerRows">
                                    <div class="customLiveSearchElement" v-on:click="customsBrokerSelected(row)">{{ row.display }}</div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            
                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="fdaRegistration">FDA Registration</label>
                                <input type="text" :disabled="!isCompanyOwner" id="fdaRegistration" name="fdaRegistration" v-model="fdaRegistration" class="form-control">
                              </div>
                            </div>

                            <div class="col-12 col-sm-6">
                              <div class="form-group">
                                <label for="website">Pro Forma Signature</label>
                                <input type="text" :disabled="!isCompanyOwner" id="proformaSignature" name="proformaSignature" v-model="proformaSignature" class="form-control">
                              </div>
                            </div>


                          </div>
                        </div>

                        
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">

                  <div class="app-error">{{ errorMessage }}</div>
                  <p v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</p>
                  <p v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</p>
                  <p v-show="!hasCoordinates" class="help is-danger">Could not find address coordinates. The address field is required.</p>

                  <a href="#/contact/view" class="btn btn-simple btn-link btn-wd"><i class="fa fa-times"></i> Cancel</a>
                  <button type="submit" class="btn btn-success btn-wd"><i class="fa fa-save"></i> Save</button>
                </div>
              </div>
          </div>

      </div>
      </form>

      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2022 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>




</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import entityService from '../../services/entity.service'
import Vue from 'vue'
import config from '../../config'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

import { AddressAutocompleteMixin } from '../../utils/mixins/address-auto-complete.mixin';

//auto-complete for company
var companyrows = [ ]

//auto-complete for customs broker
var customsBrokerRows = [ ]

var error = ''

export default {
  name: 'ContactEdit',
  mixins: [ AddressAutocompleteMixin ],
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
  },
  data: function () {
    return {
      errorMessage: error,
      name: '',
      email: '',
      type: 'Person',
      phoneoffice: '',
      phonecell: '',
      fax: '',
      position: '',
      company: '',
      companyId: '',
      division: '',
      address: '',
      city: '',
      postal: '',
      province: '',
      country: '',
      phone: '',
      website: '',
      customsBroker: '',
      fdaRegistration: '',
      proformaSignature: '',
      formSubmitted: false,
      companyrows: companyrows,
      customsBrokerRows: customsBrokerRows,
      isCompanyOwner: false,
    }
  },
  beforeMount () {
    error = ''
  },
  async mounted() {
    this.initContactForm();
    $(document).ready(function() {
      $('input').attr('autocomplete', 'new-password');
    });
    await this.GoogleMapsApi.useAutocomplete('contactEditAddressAutoComplete', (autocomplete) => {
      const fullAddress = this.GoogleMapsApi.getFullAddressString(autocomplete);      
      
      const addressComponents = this.GoogleMapsApi.getAddressComponents(autocomplete);
      console.log("Place Changed addressComponents", addressComponents);
      this.fullAddress = fullAddress;
      this.address = addressComponents.address;
      this.city = addressComponents.city;
      this.province = addressComponents.province;
      this.postal = addressComponents.postal;
      this.country = addressComponents.country;

      const addressCoordinates = this.GoogleMapsApi.getAddressCoordinates(autocomplete);
      this.addressCoordinates = {
        lat: addressCoordinates.lat,
        lng: addressCoordinates.lng,
      }
    });
  },
  beforeDestroy(){
    this.GoogleMapsApi.cleanupAutocomplete('contactEditAddressAutoComplete');
  },
  computed: {
    hasCoordinates() {
      return this.addressCoordinates.lat !== null && this.addressCoordinates.lng !== null;
    }
  },
  methods: {
    onProvinceChange(prov)
    {
      // console.log("prov change!");
      if (prov == "AB" || prov == "BC" || prov == "MB" || prov == "NB" || prov == "NF" || prov == "NT" || prov == "NS" || prov == "NU" || prov == "ON" || prov == "PE" || prov == "QC" || prov == "PE" || prov == "QC" || prov == "SK" || prov == "YT")
      {
        this.country = "Canada";
      }
      else
      {
        this.country = "United States";
      }
    },


    validateBeforeSubmit(e) {
      // console.log("validateBeforeSubmit()");
      this.$validator.validateAll();
      if (!this.errors.any() && this.hasCoordinates) {
          this.submitForm();
      }
      else {
        // console.log("Validation: " + JSON.stringify(this.errors));
      }
    },
    submitForm(){
      this.formSubmitted = true;
      this.saveContact();
    },

    initContactForm: async function () {

      var vm = this;
      apiService.get('/kong/api/v1/entity/', {
        headers: { 'X-Raefton-Email': localStorage.id_token_for }
      }).then(function (response) {
        var entity = response.data.Result
        // console.log(JSON.stringify(entity));

        vm.name = entity.name;
        vm.email = entity.email;
        vm.phoneoffice = entity.phoneoffice;
        vm.phonecell = entity.phonecell;
        vm.fax = entity.fax;
        vm.position = entity.position;
        vm.company = entity.company;
        vm.companyId = entity.companyId
        vm.division = entity.division;

        if (vm.company != null)
        {
          vm.companyLiveSearch(null);

          // after golang is retired use this
          //const companyRow = await apiService.get(`/company/${vm.companyId}`);
          //vm.companySelected(companyRow);

        }
        else
        {
          console.log('USING ENTITY', entity);
          vm.fullAddress = entity.fullAddress;
          vm.address = entity.address;
          vm.city = entity.city;
          vm.postal = entity.postal;
          vm.province = entity.province;
          vm.country = entity.country;
          vm.phone = entity.phone;
          vm.addressCoordinates = entity.addressCoordinates;
        }

        document.getElementById("name").removeAttribute("disabled");
        document.getElementById("company").removeAttribute("disabled");
        document.getElementById("division").removeAttribute("disabled");
      });

    },

    companyLiveSearch: function (event) {

      // console.log("companyLiveSearch " + event);
      var vm = this;
      var entry = this.company
      // console.log("auto: " + entry);
      if (entry.length < 2) {
        document.getElementById('companyLiveSearch').style.display = 'none'
        this.phone = "";
        this.fullAddress = "";
        this.address = "";
        this.postal = "";
        this.city = "";
        this.province = "";
        this.country = "";
        this.website = "";
        this.division = "";
      } else {

        // Find Matches
        const body = {
          "company": { "regex": `^${entry}`, "flags": "i" }
        }
        console.log(body);
        apiService.post('/company/search/', body).then(function (response) {

          // Pop everything off
          while(companyrows.length > 0) companyrows.pop();

          for (var i = 0; i < response.data.length; i++) {
            var companyRow = {
              id: response.data[i]._id,
              company: response.data[i].company,
              division: response.data[i].division,
              phone: response.data[i].phone, 
              fullAddress: response.data[i].fullAddress, 
              address: response.data[i].address, 
              postal: response.data[i].postal, 
              city: response.data[i].city,
              province: response.data[i].province, 
              country: response.data[i].country,
              addressCoordinates: response.data[i].addressCoordinates,
              website: response.data[i].website,
              display: response.data[i].company,
              customsBroker: response.data[i].customsBroker,
              fdaRegistration: response.data[i].fdaRegistration,
              proformaSignature: response.data[i].proformaSignature,
              owner: response.data[i].owner,
            };

            if (event == null)
            {
              if (companyRow.company == vm.company && companyRow.division == vm.division)
              {
                vm.companySelected(companyRow);
                return;
              }
            }
            else
            {
              if (companyRow.division != null && companyRow.division.length > 0) companyRow.display += " - " + companyRow.division;
              companyrows.push(companyRow);
            }
            
          }
          document.getElementById('companyLiveSearch').style.display = 'block'
        })
        .catch(function (error) {
          // console.log('company auto complete error: ' + JSON.stringify(error))
          while(companyrows.length > 0) companyrows.pop();
          document.getElementById('companyLiveSearch').style.display = 'block'
        })


        if (event != null) {
          // Sort it all
          companyrows.sort()

          //they are typing a new company, enable form
          console.log("---- new company");
          document.getElementById("phone").removeAttribute("disabled");
          document.getElementById("contactEditAddressAutoComplete").removeAttribute("disabled");
          document.getElementById("address").removeAttribute("disabled");
          document.getElementById("postal").removeAttribute("disabled");
          document.getElementById("city").removeAttribute("disabled");
          document.getElementById("province").removeAttribute("disabled");
          document.getElementById("country").removeAttribute("disabled");
          document.getElementById("website").removeAttribute("disabled");
          document.getElementById("customsBroker").removeAttribute("disabled");
          document.getElementById("fdaRegistration").removeAttribute("disabled");
          document.getElementById("proformaSignature").removeAttribute("disabled");
        }
      }
    },

    companySelected: function (row) {
      console.log("-----------companySelected", row);
      // console.log( JSON.stringify(row) );
      document.getElementById('companyLiveSearch').style.display = 'none'
      this.phone = row.phone
      this.fullAddress = row.fullAddress
      this.address = row.address
      this.postal = row.postal
      this.city = row.city
      this.province = row.province
      this.country = row.country
      this.addressCoordinates = row.addressCoordinates
      this.website = row.website
      this.company = row.company
      this.companyId = row.id
      this.division = row.division
      this.customsBroker = row.customsBroker
      this.fdaRegistration = row.fdaRegistration
      this.proformaSignature = row.proformaSignature

      console.log(this.email + " ------------------ " + row.owner);
      if (row.owner == this.email) {
        //they are owner of this company, let them edit it
        this.isCompanyOwner = true;
        console.log("isowner " + this.isCompanyOwner);
      } else {
        this.isCompanyOwner = false;
      }

    },

    divisionChange: function() {
      console.log("-------------- divisionChange")
      document.getElementById('companyLiveSearch').style.display = 'none'

      //they are typing a new division, enable form and clear address fields
      document.getElementById("phone").removeAttribute("disabled");
      document.getElementById("contactEditAddressAutoComplete").removeAttribute("disabled");
      document.getElementById("address").removeAttribute("disabled");
      document.getElementById("postal").removeAttribute("disabled");
      document.getElementById("city").removeAttribute("disabled");
      document.getElementById("province").removeAttribute("disabled");
      document.getElementById("country").removeAttribute("disabled");
      document.getElementById("website").removeAttribute("disabled");
      document.getElementById("customsBroker").removeAttribute("disabled");
      document.getElementById("fdaRegistration").removeAttribute("disabled");
      document.getElementById("proformaSignature").removeAttribute("disabled");

      this.phone = "";
      this.address = "";
      this.postal = "";
      this.city = "";
      this.province = "";
      this.country = "";
      this.website = "";
      this.customsBroker = "";
      this.fdaRegistration = "";
      this.proformaSignature = "";
    },

    customsBrokerLiveSearch: function (e) {
      // Check if anything has been submitted
      if (this.customsBroker.length < 3) {
        this.dissmissAutoCompletes();
      } else {
        this.liveSearching = true;

        // Find Matches
        entityService.get(this.customsBroker)
        .then(function (res) {

          // Pop everything off
          var len = customsBrokerRows.length;
          for (var j = 0; j < len; j++) {
            customsBrokerRows.pop()
          }

          customsBrokerRows.push(
            ...res.data
              .map((row) => {
                if (row.company != null && row.company.length > 0) row.display += ", " + row.company;
                if (row.division != null && row.division.length > 0) row.display += " - " + row.division;
                if (row.city != null) row.display += ", " + row.city;
                return row;
              }));
        })
        .catch(function (error) {

          console.log('customs broker auto complete error: ' + JSON.stringify(error))
          while(customsBrokerRows.length > 0) { customsBrokerRows.pop(); }

        }).finally(() => this.showAutoComplete('customsBrokerLiveSearch'));
        // Sort it all
        customsBrokerRows.sort()
      }
    },

    customsBrokerSelected: function (row) {
      console.log('customs broker selected: ' + JSON.stringify(row))
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      this.customsBroker = row.company;
    },

    dissmissAutoCompletes: function() {
      console.log("dissmissAutoCompletes");
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      if(!this.liveSearching) return;
      document.getElementById(id).style.display = 'block';
    },


    saveContact: async function (event) {

      var vm = this;

      // Send API request
      try
      {
        const contactResp = await apiService.put('/kong/api/v1/entity/', {
          name: this.name,
          email: this.email,
          type: this.type,
          phoneoffice: this.phoneoffice,
          phonecell: this.phonecell,
          fax: this.fax,
          position: this.position,
          fullAddress: this.fullAddress,
          address: this.address,
          postal: this.postal,
          city: this.city,
          province: this.province,
          country: this.country,
          addressCoordinates: this.addressCoordinates,
          phone: this.phone,
          website: this.website,
          company: this.company,
          companyId: this.companyId,
          division: this.division,
        });
        localStorage.local_name = vm.name;
 
        if (this.isCompanyOwner) {
          const patchBody = {
            country: this.country,
            phone: this.phone,
            website: this.website,
            customsBroker: this.customsBroker,
            fdaRegistration: this.fdaRegistration,
            proformaSignature: this.proformaSignature,
          };
          const resp = await apiService.patch(`/company/${this.companyId}`, patchBody);
          console.log(resp);
        }

        Vue.toasted.success("Successfully Edited Contact", { duration: 3500 });
        router.push('/rfq/view');
      }
      catch(error) {
        // console.log( JSON.stringify(error) );
        Vue.toasted.error(error, { duration: 3500 })
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// edit.vue?c2f753c6